// extracted by mini-css-extract-plugin
module.exports = {"clickable":"styles_clickable__B61vf","large":"styles_large__1-6FR"};